export default __webpack_public_path__ + "static/media/ICON15.4d64c5d6.svg";